var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconButton',{staticClass:"p-btn",class:{
	all: _vm.all,
	desktop: _vm.desktop,
	mobile: _vm.mobile,
},attrs:{"icon":_vm.icon},on:{"click":_vm.toggle}})}
var staticRenderFns = []

export { render, staticRenderFns }